module.exports = __webpack_public_path__ + "media/honey-icons/icon-full-access-072ce907.svg";